// import { useContext } from "react";
// import { showToast } from '../../../Components/Toaster/Toaster';
// import { EditSizeChartContext } from "../../../Context/EditSizeChartContext";

// function FormInputSection({ externalCSS, centimeters, row_id, inches, spec, isLast }) {
//     const { sizeChartFormData, setSizeChartFormData } = useContext(EditSizeChartContext);

//     const handleInputChange = (id, field, unit = null, value) => {
//         if (value >= 0) {
//             const updatedData = sizeChartFormData.map((item) => {
//                 if (item.id === id) {
//                     if (unit) {
//                         return {
//                             ...item,
//                             [field]: { ...item[field], [unit]: value }
//                         };
//                     } else {
//                         return { ...item, [field]: value };
//                     }
//                 }
//                 return item;
//             });

//             setSizeChartFormData(updatedData);
//         } else {
//             showToast('Please enter a valid positive value.', 'warning');
//         }
//     };

//     return (
//         <div
//             className={`w-[180px] ${externalCSS || ''} flex items-center shrink-0 ${
//                 !isLast ? 'border-r border-[#EAEAEA]' : ''
//             }`}
//         >
//             <div className="w-1/2 px-4 py-3 border-r border-[#EAEAEA]">
//                 <input
//                     type="number"
//                     name={`${spec}_cm`}
//                     value={centimeters}
//                     onChange={(e) => handleInputChange(row_id, spec, 'cm', e.target.value)}
//                     placeholder="cm"
//                     className="w-full outline-none placeholder:text-center text-center"
//                 />
//             </div>

//             <div className="w-1/2 px-6 py-3">
//                 <input
//                     type="number"
//                     name={`${spec}_in`}
//                     value={inches}
//                     onChange={(e) => handleInputChange(row_id, spec, 'in', e.target.value)}
//                     placeholder="in"
//                     className="w-full outline-none placeholder:text-center text-center"
//                 />
//             </div>
//         </div>
//     );
// }

// export default FormInputSection;
import { useContext } from "react";
import { showToast } from '../../../Components/Toaster/Toaster';
import { EditSizeChartContext } from "../../../Context/EditSizeChartContext";

function FormInputSection({ externalCSS, centimeters, inches, row_id, spec, isLast, label }) {
    const { sizeChartFormData, setSizeChartFormData } = useContext(EditSizeChartContext);

    const handleInputChange = (id, field, unit = null, value) => {
        if (value >= 0) {
            const updatedData = sizeChartFormData.map((item) => {
                if (item.id === id) {
                    if (unit) {
                        return {
                            ...item,
                            [field]: { ...item[field], [unit]: value }
                        };
                    } else {
                        return { ...item, [field]: value };
                    }
                }
                return item;
            });

            setSizeChartFormData(updatedData);
        } else {
            showToast('Please enter a valid positive value.', 'warning');
        }
    };

    return (
        <div
            className={`w-[180px] ${externalCSS || ''} flex flex-col items-center shrink-0 ${
                !isLast ? 'border-r border-[#EAEAEA]' : ''
            }`}
        >
            {label && (
                <p className="text-sm font-medium text-[#121212] text-center mt-1 mb-1">
                    {label}
                </p>
            )}
            <div className="flex w-full">
                <div className="w-1/2 px-4 py-3 border-r border-[#EAEAEA]">
                    <input
                        type="number"
                        name={`${spec}_cm`}
                        value={centimeters}
                        onChange={(e) => handleInputChange(row_id, spec, 'cm', e.target.value)}
                        placeholder="cm"
                        className="w-full outline-none placeholder:text-center text-center"
                    />
                </div>

                <div className="w-1/2 px-6 py-3">
                    <input
                        type="number"
                        name={`${spec}_in`}
                        value={inches}
                        onChange={(e) => handleInputChange(row_id, spec, 'in', e.target.value)}
                        placeholder="in"
                        className="w-full outline-none placeholder:text-center text-center"
                    />
                </div>
            </div>
        </div>
    );
}

export default FormInputSection;
